import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function RotateRight({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <RotateRight.Outline {...props} />
  ) : (
    <RotateRight.Solid {...props} />
  );
}

RotateRight.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.3771 6.26508C12.3773 5.46806 11.1277 5.05043 9.84959 5.08609C8.57146 5.12176 7.34715 5.60841 6.39333 6.45994C5.4395 7.31146 4.81765 8.47296 4.63783 9.73887C4.45801 11.0048 4.73181 12.2935 5.41078 13.377C6.08974 14.4604 7.1301 15.2688 8.34774 15.659C9.56538 16.0491 10.8818 15.996 12.064 15.5089C12.3832 15.3774 12.7485 15.5296 12.88 15.8487C13.0115 16.1679 12.8593 16.5332 12.5402 16.6647C11.0851 17.2642 9.46493 17.3296 7.96629 16.8493C6.46766 16.3691 5.18722 15.3742 4.35157 14.0407C3.51592 12.7072 3.17894 11.1211 3.40026 9.56308C3.62157 8.00503 4.38692 6.5755 5.56086 5.52746C6.7348 4.47943 8.24164 3.88047 9.81472 3.83658C11.3878 3.79269 12.9257 4.30669 14.1563 5.28764C15.3868 6.26858 16.2307 7.65321 16.5385 9.1965C16.6061 9.53501 16.3864 9.86416 16.0479 9.93169C15.7094 9.99921 15.3802 9.77954 15.3127 9.44103C15.0625 8.18711 14.3769 7.06209 13.3771 6.26508Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.099 10.6659L12.2454 9.08137C11.9261 8.9501 11.7737 8.58489 11.905 8.26564C12.0363 7.9464 12.4015 7.79401 12.7207 7.92528L15.9963 9.27214L17.3432 5.99657C17.4744 5.67732 17.8396 5.52494 18.1589 5.65621C18.4781 5.78748 18.6305 6.15269 18.4993 6.47193L16.9147 10.3255C16.7834 10.6448 16.4182 10.7972 16.099 10.6659Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

RotateRight.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.3771 6.26508C12.3773 5.46806 11.1277 5.05043 9.84959 5.08609C8.57146 5.12176 7.34715 5.60841 6.39333 6.45994C5.4395 7.31146 4.81765 8.47296 4.63783 9.73887C4.45801 11.0048 4.73181 12.2935 5.41078 13.377C6.08974 14.4604 7.1301 15.2688 8.34774 15.659C9.56538 16.0491 10.8818 15.996 12.064 15.5089C12.3832 15.3774 12.7485 15.5296 12.88 15.8487C13.0115 16.1679 12.8593 16.5332 12.5402 16.6647C11.0851 17.2642 9.46493 17.3296 7.96629 16.8493C6.46766 16.3691 5.18722 15.3742 4.35157 14.0407C3.51592 12.7072 3.17894 11.1211 3.40026 9.56308C3.62157 8.00503 4.38692 6.5755 5.56086 5.52746C6.7348 4.47943 8.24164 3.88047 9.81472 3.83658C11.3878 3.79269 12.9257 4.30669 14.1563 5.28764C15.3868 6.26858 16.2307 7.65321 16.5385 9.1965C16.6061 9.53501 16.3864 9.86416 16.0479 9.93169C15.7094 9.99921 15.3802 9.77954 15.3127 9.44103C15.0625 8.18711 14.3769 7.06209 13.3771 6.26508Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.099 10.6659L12.2454 9.08137C11.9261 8.9501 11.7737 8.58489 11.905 8.26564C12.0363 7.9464 12.4015 7.79401 12.7207 7.92528L15.9963 9.27214L17.3432 5.99657C17.4744 5.67732 17.8396 5.52494 18.1589 5.65621C18.4781 5.78748 18.6305 6.15269 18.4993 6.47193L16.9147 10.3255C16.7834 10.6448 16.4182 10.7972 16.099 10.6659Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
